export default function buy(buyCode, basicInfo, activityId) {
  const dialogContent =
    `
    <div class="dialog-config-content">
    <ul>
    <li>
      <div class="dn-row">
        <div class="dn-col-xs-24 dn-col-sm-10">
          <label for="dialog-region">
            请选择地域：
          </label>
        </div>
        <div class="dn-col-xs-24 dn-col-sm-12">
          <select id="dialog-region">
          <option value="cn-shenzhen">
          华南1
          </option>
          <option value="cn-beijing">
              华北2
            </option>
            <option value="cn-huhehaote">
              华北5
            </option>
            <option value="cn-hangzhou">
            华东1
            </option>
            <option value="cn-shanghai">
            华东2
            </option>
          </select>
        </div>
      </div>
    </li>
</ul>
    </div>
    `;
  const Modal = window.DN.Modal;
  let buyParams = {
    "data": {
      "rds_region": "cn-shenzhen",
      "rds_dbtype": "mysql",
      "rds_dbversion": "5.7",
      "rds_nodetype": "Basic",
      "rds_web_type": "1",
      "rds_class": "mysql.n2.small.1",
      "rds_storage": "20",
      "duration": 12
    }
  };
  const h5Prams = {
    common: {
      ord_time: `${basicInfo.duration}:Year`,
      regionId: 'cn-shenzhen'
    }
  };
  // 根据basicInfo确定购买时长
  const duration = basicInfo.duration;
  buyParams.data.duration = duration * 12;
  buyParams.data.rds_groupBuyCode = buyCode;
  buyParams.data.rds_activityId = activityId;
  Modal.dialog({
    title: '购买确认',
    content: function makeContent() {
      const $content = $(dialogContent);
      // 设置地域默认值
      buyParams.data.rds_region = 'cn-shenzhen';
      $content.find('#dialog-region').on('change', function () {
        const val = $(this).val();
        buyParams.data.rds_region = val;
        h5Prams.common.regionId = val;
      });
      return $content;
    },
    button: [
      {
        text: '立即购买',
        onClick: () => {
          // PC和H5分开传递
          if ($(window).width() <= 768) {
            // H5的逻辑
            const url = `https://h5.m.aliyun.com/alicloud/freetier2.html?request=${encodeURIComponent(JSON.stringify(h5Prams))}&groupBuyCode=${buyCode}&kaleidoActivityId=${activityId}&activityId=rds_buy_group`;
            location.href = url;
          } else {
            const url = `https://rdsnew.console.aliyun.com/console/buy#/create/rds?initData=${encodeURIComponent(JSON.stringify(buyParams))}`;
            location.href = url;
          }
        }
      }
    ]
  })
}


// WEBPACK FOOTER //
// ./src/rds/buy.js